require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/es7.symbol.observable.js
// module id = 678
// module chunks = 0